import { Block } from "baseui/block"
import { useStyletron } from "baseui";
import { FaLightbulb } from "react-icons/fa";
import { LabelSmall } from "baseui/typography";
import { FormattedMessage } from "react-intl";
import { useGetMatchQuery } from "../../../services/objects";
import { modelId } from './types'
import { Badge } from "baseui/badge";

const ActiveLightsPanel = (props: { parentId: string, resourceGroupId: string }) => {
    const [, theme] = useStyletron();
    // api
    const { data: activeLights } = useGetMatchQuery({
        objectId: props.parentId,
        resourceGroupId: props.resourceGroupId,
        hops: '..5',
        relationship: 'Contains',
        modelId: modelId,
        queryParameters: 'IsOn=true'
    });


    const activeLightsCnt = activeLights?.length ?? 0;

    return (
        <>
            {activeLightsCnt > 0 &&
                <Block display='inline-flex' alignItems={'baseline'} gridGap={theme.sizing.scale200}>
                    <FaLightbulb color={theme.colors.warning} size={theme.sizing.scale500} />
                    <LabelSmall>{activeLightsCnt}</LabelSmall>
                    {activeLightsCnt === 1 ?
                        <Badge hierarchy="secondary" color="warning" content={<FormattedMessage id="Light.LightOn" defaultMessage="Light is on" />}></Badge>
                        :
                        <Badge hierarchy="secondary" color="warning" content={<FormattedMessage id="Light.LightsOn" defaultMessage="Lights are  on" />}></Badge>
                    }
                </Block>
            }
        </>
    )
}

export default ActiveLightsPanel;